import { RootState } from './../redux/store';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { IVehicle } from '../models/IVehicle/IVehicle';
import { API_BASE_URL } from '../helpers/common';

export const vehiclesApi = createApi({
  reducerPath: 'vehiclesApi',
  tagTypes: ['Vehicle'],
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: async (headers, { getState }) => {
      const token = (getState() as RootState).user.info.accessToken;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getVehicles: build.query<IVehicle[], { query: string; line_id: string }>({
      transformResponse: (response: { data: { data: IVehicle[] } }) =>
        response.data.data,
      query: ({ query, line_id }) => ({
        url: '/vehicles',
        method: 'GET',
        params: {
          search: query,
          line_id,
        },
      }),
      providesTags: (result) => ['Vehicle'],
    }),
    createVehicle: build.mutation<IVehicle[], IVehicle>({
      transformResponse: (response: { data: { data: IVehicle[] } }) =>
        response.data.data,
      query: (newVehicle) => ({
        url: '/vehicles',
        method: 'POST',
        body: newVehicle,
      }),
      invalidatesTags: ['Vehicle'],
    }),
    updateVehicle: build.mutation<IVehicle[], IVehicle>({
      transformResponse: (response: { data: { data: IVehicle[] } }) =>
        response.data.data,
      query: (newVehicle) => ({
        url: `/api/vehicles/${newVehicle.id}`,
        method: 'POST',
        body: newVehicle,
      }),
      invalidatesTags: ['Vehicle'],
    }),
    deleteVehicle: build.mutation<IVehicle[], number>({
      query: (id) => ({
        url: `/api/vehicles/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Vehicle'],
    }),
  }),
});
